var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryDocuments = function SvgLibraryDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "library_documents_svg2__a",
    x1: 32.3,
    x2: 172.1,
    y1: 178.6,
    y2: 31.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_documents_svg2__a",
    id: "library_documents_svg2__b",
    x1: 20.9,
    x2: 160.7,
    y1: 167.8,
    y2: 20.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_documents_svg2__a",
    id: "library_documents_svg2__c",
    x1: 31.3,
    x2: 171.1,
    y1: 177.7,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_documents_svg2__a",
    id: "library_documents_svg2__d",
    x1: 41.7,
    x2: 181.5,
    y1: 187.6,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_documents_svg2__a",
    id: "library_documents_svg2__e",
    x1: 52.1,
    x2: 191.9,
    y1: 197.4,
    y2: 50.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_documents_svg2__a",
    id: "library_documents_svg2__f",
    x1: 62.5,
    x2: 202.3,
    y1: 207.3,
    y2: 60.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.4 25.2c-.1-.1-.3-.2-.4-.4L175.2 3l-.3-.3c-.9-.9-1.8-1.8-3.6-1.8H76.7c-2.8 0-5 2.2-5 5v15.4L38.4 27c-2.7.5-4.5 3-4 5.7l1.7 9.9C25.3 46.2 14.2 50 3.4 53.9c-2.5.9-3.9 3.7-3 6.3l21.4 59.4c.4 1.2 1.6 1.9 2.8 1.9s.7 0 1-.2c1.5-.5 2.3-2.2 1.8-3.7L6.1 59.1c10.1-3.6 20.6-7.2 30.8-10.6L47 107.2l11.6 67.6c.4 2.4 2.5 4.1 4.9 4.1h.8l31.4-5.4 24.5-4.2-36.9 13.3-29.1 10.5-22.6-62.8c-.5-1.5-2.2-2.3-3.7-1.8s-2.3 2.2-1.8 3.7L49 195.9c.4 1.2 1.4 2.2 2.5 2.8.7.3 1.4.5 2.1.5s1.1 0 1.7-.3l29.9-10.8 68-24.4 13-2.2h28.7c2.8 0 5-2.3 5-5v-128c0-1.8-1-2.6-1.6-3.3Zm-7.8.7h-15c-.7 0-2.3 0-2.8-.4 0 0-.2-.4-.2-1V8.7zM77.5 155.4V98.3c0-1.6-1.3-2.9-2.9-2.9s-2.9 1.3-2.9 2.9v57.9c0 2.8 2.2 5 5 5h55l-36.9 6.3-30.5 5.2L52.9 106 40.3 32.5l31.4-5.4v57.4c0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9V6.8h89.2v17.7c0 2.1.7 3.9 2 5.2 2 2 4.8 2.1 6.5 2.1h18.9v123.6H77.4Z",
    style: {
      fill: "url(#library_documents_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3 43.5H94.5c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h83.8c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#library_documents_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3 64.3H94.5c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h83.8c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#library_documents_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3 85.2H94.5c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h83.8c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#library_documents_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3 106H94.5c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h83.8c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#library_documents_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3 126.8H94.5c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h83.8c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#library_documents_svg2__f)"
    }
  }));
};
export default SvgLibraryDocuments;